import { mapState } from "vuex";
import RevenueEvolutionCandle from "@/components/brand_portfolio/RevenueEvolutionCandle";
import AppIcon from "@/components/AppIcon";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
export default {
  name: "RevenueEvolutionGraph",
  components: {
    RevenueEvolutionCandle,
    AppIcon,
    CurrencyValue
  },
  emits: ["hoveringCandle"],
  props: {
    revenueData: {
      type: Array,
      default: []
    },
    periodLength: {
      type: Number,
      default: 14
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    hovering_index: {
      type: Number,
      default: -1
    },
    value_key: {
      type: String,
      default: "revenue_evol_vs_last_year"
    }
  },
  data() {
    return {
      defaultData: {
        ROAS: null,
        TACOS: null,
        label: null,
        revenue: null,
        revenue_evol_vs_last_year: null,
        revenue_evol_vs_previous_period: null,
        roas_evol_vs_previous_period: null,
        spend: null,
        spend_evol_vs_previous_period: null,
        tacos_evol_vs_previous_period: null
      }
    };
  },
  computed: {
    ...mapState({}),
    maxValue() {
      const valueArray = this.revenueData.map(row => Math.abs(Number(row?.[this.value_key])));
      return valueArray.length > 0 ? Math.max(...valueArray) : 0;
    }
  },
  methods: {
    hoveringCandle(index) {
      this.$emit("hoveringCandle", index);
    }
  }
};